// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2_w0N","boxTitle":"Qualiphy_boxTitle__NhdNn","box":"Qualiphy_box__14a0p","toggleWrap":"Qualiphy_toggleWrap__DxBz_"};